import { type ResourcesConfig } from 'aws-amplify';

const ENV_CONFIGS = {
  dev: {
    userPoolId: 'us-west-2_juvBFA6kG',
    userPoolClientId: '70105j8cfp0i4pmvqbpbh9013m',
    domain: 'dev-mbenav-pattern-warehouse-v3.auth.us-west-2.amazoncognito.com',
    redirectSignIn: 'https://localhost:3000/callback',
    redirectSignOut: 'https://localhost:3000/',
  },
  beta: {
    userPoolId: 'us-west-2_oGWlmo7i8',
    userPoolClientId: '3v8o63tmrd39opkpo48crjuhr9',
    domain: 'beta-pattern-warehouse-v3.auth.us-west-2.amazoncognito.com',
    redirectSignIn: 'https://www.beta.freepatternwarehouse.com/callback',
    redirectSignOut: 'https://www.beta.freepatternwarehouse.com/',
  },
  prod: {
    userPoolId: 'us-west-2_RfRIaeqJb',
    userPoolClientId: '5cbruq95okldaqn15bir2r8998',
    domain: 'prod-pattern-warehouse-v3.auth.us-west-2.amazoncognito.com',
    redirectSignIn: 'https://www.freepatternwarehouse.com/callback',
    redirectSignOut: 'https://www.freepatternwarehouse.com/',
  },
} as const;

const ENV = (import.meta.env.VITE_ENV || 'dev') as keyof typeof ENV_CONFIGS;
const config = ENV_CONFIGS[ENV];

// DEBUG: Log all auth configuration
console.log('🔐 [AUTH DEBUG] Environment:', ENV);
console.log('🔐 [AUTH DEBUG] VITE_ENV:', import.meta.env.VITE_ENV);
console.log('🔐 [AUTH DEBUG] Config:', config);
console.log('🔐 [AUTH DEBUG] User Pool ID:', config.userPoolId);
console.log('🔐 [AUTH DEBUG] Client ID:', config.userPoolClientId);
console.log('🔐 [AUTH DEBUG] Domain:', config.domain);
console.log('🔐 [AUTH DEBUG] Redirect Sign In:', config.redirectSignIn);
console.log('🔐 [AUTH DEBUG] Redirect Sign Out:', config.redirectSignOut);
console.log('🔐 [AUTH DEBUG] Current Origin:', window.location.origin);

export const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolId: config.userPoolId,
    userPoolClientId: config.userPoolClientId,
    loginWith: {
      oauth: {
        domain: config.domain,
        scopes: ['openid', 'profile', 'email'],
        redirectSignIn: [config.redirectSignIn],
        redirectSignOut: [config.redirectSignOut],
        responseType: 'code',
        providers: ['Amazon'],
      },
    },
  },
};

console.log('🔐 [AUTH DEBUG] Final Auth Config:', authConfig);
